import VirtualTourViewer from '../../components/VirtualTourViewer';

function ArtRoom({title = "Le Moulin des Remparts"}) {
  const layouts = [
    {
        id: 'layout01',
        image: '/tours/moulin-thumb01.avif',
        title: 'Mariage',
        description: '80 personnes assises',
        source: 'https://3d.thepamarket.com/moulin-01/',
        alt: 'Banquet layout'
        },

        {
        id: 'layout02',
        image: '/tours/moulin-thumb02.avif',
        title: 'Ceremonie',
        description: '84 personnes assises',
        source: 'https://3d.thepamarket.com/moulin-03/',
        alt: 'Ceremony layout'
        },

        {
        id: 'layout03',
        image: '/tours/moulin-thumb03.avif',
        title: '6 tables + manges-debout',
        description: 'Anniversaire et autres évènements',
        source: 'https://3d.thepamarket.com/moulin-04/',
        alt: 'Misc layout'
        }
  ];

  return (
    <VirtualTourViewer 
        layouts={layouts}
        title={title}
    />
  );
}

export default ArtRoom;